// extracted by mini-css-extract-plugin
export default {"list":"styles_list__9fT1r","reviewAndSignButtonText":"styles_reviewAndSignButtonText__m8o31"};